"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DetailsHeader_1 = require("./DetailsHeader");
exports.DetailsHeader = DetailsHeader_1.DetailsHeader;
var DetailsHeaderEdit_1 = require("./DetailsHeaderEdit");
exports.DetailsHeaderEdit = DetailsHeaderEdit_1.DetailsHeaderEdit;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9jb21wb25lbnRzL0RldGFpbHNIZWFkZXIvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSxpREFBNkM7QUFBckMsd0NBQUEsYUFBYSxDQUFBO0FBQ3JCLHlEQUFxRDtBQUE3QyxnREFBQSxpQkFBaUIsQ0FBQSJ9